import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, withCtx as _withCtx, toDisplayString as _toDisplayString, createBlock as _createBlock, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "grid grid-cols-4 lg:grid-cols-5 gap-5 p-5 rounded-b-lg" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "flex justify-between p-3 border-b-2 border-gray-blue-300 dark:border-gray-bluer-400 h-11" }, null, -1)
const _hoisted_3 = { class: "p-3" }
const _hoisted_4 = {
  class: "relative flex-shrink-0 w-full",
  style: {"padding-bottom":"80%"}
}
const _hoisted_5 = { class: "absolute inset-0 inline-flex items-center justify-center bg-gray-blue-500 dark:bg-gray-bluer-400 rounded-sm text-xl lg:text-3xl font-bold text-gray-bluer-200 uppercase" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "flex items-center justify-between space-x-3 mt-3" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "font-bold text-gray-bluer-300 text-sm truncate" }, "Go back")
], -1)
const _hoisted_7 = ["onClick"]
const _hoisted_8 = ["onClick"]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "text-sm font-bold text-gray-bluer-200" }, "Folder", -1)
const _hoisted_10 = {
  key: 0,
  class: "flex justify-start space-x-2 text-xs font-medium"
}
const _hoisted_11 = ["onClick"]
const _hoisted_12 = { class: "p-3" }
const _hoisted_13 = {
  class: "relative flex-shrink-0 w-full",
  style: {"padding-bottom":"80%"}
}
const _hoisted_14 = { class: "absolute inset-0 inline-flex items-center justify-center bg-gray-blue-500 dark:bg-gray-bluer-400 rounded-sm text-xl lg:text-3xl font-bold text-gray-bluer-200 uppercase" }
const _hoisted_15 = { class: "flex items-center justify-between space-x-3 mt-3" }
const _hoisted_16 = { class: "font-bold text-gray-bluer-300 text-sm truncate" }
const _hoisted_17 = ["checked", "onClick"]
const _hoisted_18 = { class: "flex justify-start space-x-2 text-xs font-medium" }
const _hoisted_19 = { key: 0 }
const _hoisted_20 = ["onClick"]
const _hoisted_21 = { key: 1 }
const _hoisted_22 = ["onClick"]
const _hoisted_23 = ["onClick"]
const _hoisted_24 = ["onClick"]
const _hoisted_25 = ["onClick"]
const _hoisted_26 = ["onClick"]
const _hoisted_27 = {
  class: "group relative flex-shrink-0 w-full",
  style: {"padding-bottom":"80%"}
}
const _hoisted_28 = {
  key: 1,
  class: "absolute inset-0 inline-flex items-center justify-center bg-gray-blue-500 rounded-sm text-xl lg:text-3xl font-bold text-gray-bluer-200 uppercase"
}
const _hoisted_29 = {
  key: 2,
  class: "opacity-0 group-hover:opacity-100 inline-flex absolute inset-0 items-center justify-center transition duration-150 ease-in-out"
}
const _hoisted_30 = ["onClick"]
const _hoisted_31 = { class: "flex items-center justify-between space-x-3 mt-3" }
const _hoisted_32 = { class: "font-bold text-gray-bluer-300 text-sm truncate" }
const _hoisted_33 = { class: "font-bold text-gray-bluer-200 text-xs uppercase" }

import { useStore } from "vuex";
import { load }     from "../mixin";


export default /*#__PURE__*/_defineComponent({
  props: {
        canDeleteFolder: {
            type:     Boolean,
            default:  true,
            required: false
        },
        canDownload: {
            type:     Boolean,
            default:  true,
            required: false
        },
        canReplace: {
            type:     Boolean,
            default:  true,
            required: false
        },
        searchAllMode: {
            type:     Boolean,
            default:  false,
            required: false
        },
    },
  emits: [ 'preview', 'download', 'replace', 'crop' ],
  setup(__props, { emit }) {

const props = __props



const store = useStore();

const {
          backPath,
          searchResults,
          allFilesSelected,
          selectedFiles,
          mode,
          activeFile,
          filteredFiles,
          setPath,
          setAllFilesSelected,
          setSelectedFiles,
          setFile,
          setModal,
          deleteFolder,
          deleteFile,
          selectFile,
          toggleAllFilesSelection,
          toggleFileSelection
      } = load( store );

 


return (_ctx: any,_cache: any) => {
  const _component_x_icon = _resolveComponent("x-icon")!
  const _component_x_popper = _resolveComponent("x-popper")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(backPath) && __props.searchAllMode === false)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "border-2 border-gray-blue-200 dark:border-gray-bluer-400 rounded-sm cursor-pointer",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(setPath)(_unref(backPath))))
        }, [
          _hoisted_2,
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("span", _hoisted_5, [
                _createVNode(_component_x_icon, {
                  icon: "fontawesome.ellipsis",
                  class: "w-20 h-20"
                })
              ])
            ]),
            _hoisted_6
          ])
        ]))
      : _createCommentVNode("", true),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(filteredFiles), (file, index) => {
      return (_openBlock(), _createElementBlock("div", {
        key: index,
        class: _normalizeClass(["border-2 rounded-sm", {
                'border-blue': _unref(selectedFiles).indexOf( file.id ) !== -1 || ( _unref(activeFile) && _unref(activeFile).id === file.id ),
                'border-gray-blue-200 dark:border-gray-bluer-400': _unref(selectedFiles).indexOf( file.id ) === -1 && ( !_unref(activeFile) || _unref(activeFile).id !== file.id ),
                'cursor-pointer': _unref(mode) === 'field'
            }])
      }, [
        (file.type === 'folder')
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "cursor-pointer",
              onClick: ($event: any) => (_unref(setPath)(file.path))
            }, [
              _createElementVNode("div", {
                class: "flex justify-between p-3 border-b-2 border-gray-blue-300 dark:border-gray-bluer-400 cursor-pointer",
                onClick: ($event: any) => (_unref(setPath)(file.path))
              }, [
                _hoisted_9,
                (_unref(mode) !== 'field' && __props.canDeleteFolder === true)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                      _createVNode(_component_x_popper, {
                        arrow: "",
                        hover: "",
                        content: "Delete"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("a", {
                            href: "#",
                            class: "text-gray-blue-900 transition duration-150 ease-in-out hover:text-red-500",
                            onClick: _withModifiers(($event: any) => (_unref(deleteFolder)( file.path )), ["prevent"])
                          }, [
                            _createVNode(_component_x_icon, {
                              icon: "fontawesome.trash",
                              "fa-type": "fas",
                              class: "h-5 w-5"
                            })
                          ], 8, _hoisted_11)
                        ]),
                        _: 2
                      }, 1024)
                    ]))
                  : _createCommentVNode("", true)
              ], 8, _hoisted_8),
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("span", _hoisted_14, [
                    _createVNode(_component_x_icon, {
                      icon: "fontawesome.folder",
                      class: "w-20 h-20"
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("span", _hoisted_16, _toDisplayString(file.name), 1)
                ])
              ])
            ], 8, _hoisted_7))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createElementVNode("div", {
                class: _normalizeClass(["flex items-center p-3 border-b-2 border-gray-blue-300 dark:border-gray-bluer-400", { 'justify-between': _unref(mode) !== 'field', 'justify-center': _unref(mode) === 'field' }])
              }, [
                (_unref(mode) !== 'field')
                  ? (_openBlock(), _createElementBlock("input", {
                      key: 0,
                      type: "checkbox",
                      class: "focus:ring-theme-500 h-4 w-4 text-theme-600 border-gray-300 rounded dark:bg-gray-bluer-800 dark:border-gray-bluer-500",
                      checked: _unref(selectedFiles).indexOf(file.id) !== -1,
                      onClick: ($event: any) => (_unref(toggleFileSelection)( file, $event.target.checked ))
                    }, null, 8, _hoisted_17))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_18, [
                  (file.age_status)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                        _createVNode(_component_x_popper, {
                          arrow: "",
                          hover: "",
                          content: file.age_status.message
                        }, {
                          default: _withCtx(() => [
                            (file.age_status.status == 'expired')
                              ? (_openBlock(), _createBlock(_component_x_icon, {
                                  key: 0,
                                  icon: "fontawesome.exclamation-triangle",
                                  "fa-type": "fas",
                                  class: "h-5 w-5",
                                  style: {"color":"red"}
                                }))
                              : (_openBlock(), _createBlock(_component_x_icon, {
                                  key: 1,
                                  icon: "fontawesome.exclamation-triangle",
                                  "fa-type": "fas",
                                  class: "h-5 w-5",
                                  style: {"color":"orange"}
                                }))
                          ]),
                          _: 2
                        }, 1032, ["content"])
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", null, [
                    (file.is_image)
                      ? (_openBlock(), _createBlock(_component_x_popper, {
                          key: 0,
                          arrow: "",
                          hover: "",
                          content: "Crop/Resize"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("a", {
                              href: "#",
                              class: "text-gray-blue-900 transition duration-150 ease-in-out hover:text-blue-500",
                              onClick: _withModifiers(($event: any) => (emit( 'crop', index )), ["prevent"])
                            }, [
                              _createVNode(_component_x_icon, {
                                icon: "fontawesome.crop",
                                "fa-type": "fas",
                                class: "h-5 w-5"
                              })
                            ], 8, _hoisted_20)
                          ]),
                          _: 2
                        }, 1024))
                      : _createCommentVNode("", true)
                  ]),
                  (_unref(store).state.media.previewsEnabled)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                        _createVNode(_component_x_popper, {
                          arrow: "",
                          hover: "",
                          content: "Preview"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("a", {
                              href: "#",
                              class: "text-gray-blue-900 transition duration-150 ease-in-out hover:text-theme-500",
                              onClick: _withModifiers(($event: any) => (emit( 'preview', file )), ["prevent"])
                            }, [
                              _createVNode(_component_x_icon, {
                                icon: "fontawesome.eye",
                                "fa-type": "fas",
                                class: "h-5 w-5"
                              })
                            ], 8, _hoisted_22)
                          ]),
                          _: 2
                        }, 1024)
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", null, [
                    _createVNode(_component_x_popper, {
                      arrow: "",
                      hover: "",
                      content: "Replace"
                    }, {
                      default: _withCtx(() => [
                        (_unref(mode) !== 'field' && __props.canReplace === true)
                          ? (_openBlock(), _createElementBlock("a", {
                              key: 0,
                              href: "#",
                              class: "text-gray-blue-900 transition duration-150 ease-in-out hover:text-theme-500",
                              onClick: _withModifiers(($event: any) => (emit( 'replace', file )), ["prevent"])
                            }, [
                              _createVNode(_component_x_icon, {
                                icon: "fontawesome.arrow-right-arrow-left",
                                "fa-type": "fas",
                                class: "h-5 w-5"
                              })
                            ], 8, _hoisted_23))
                          : _createCommentVNode("", true)
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _createElementVNode("div", null, [
                    _createVNode(_component_x_popper, {
                      arrow: "",
                      hover: "",
                      content: "Download"
                    }, {
                      default: _withCtx(() => [
                        (_unref(mode) !== 'field' && __props.canDownload === true)
                          ? (_openBlock(), _createElementBlock("a", {
                              key: 0,
                              href: "#",
                              class: "text-gray-blue-900 transition duration-150 ease-in-out hover:text-theme-500",
                              onClick: _withModifiers(($event: any) => (emit( 'download', file )), ["prevent"])
                            }, [
                              _createVNode(_component_x_icon, {
                                icon: "fontawesome.arrow-down-to-line",
                                "fa-type": "fas",
                                class: "h-5 w-5"
                              })
                            ], 8, _hoisted_24))
                          : _createCommentVNode("", true)
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _createElementVNode("div", null, [
                    _createVNode(_component_x_popper, {
                      arrow: "",
                      hover: "",
                      content: "Delete"
                    }, {
                      default: _withCtx(() => [
                        (_unref(mode) !== 'field')
                          ? (_openBlock(), _createElementBlock("a", {
                              key: 0,
                              href: "#",
                              class: "text-gray-blue-900 transition duration-150 ease-in-out hover:text-red-500",
                              onClick: _withModifiers(($event: any) => (_unref(deleteFile)( file )), ["prevent"])
                            }, [
                              _createVNode(_component_x_icon, {
                                icon: "fontawesome.trash",
                                "fa-type": "fas",
                                class: "h-5 w-5"
                              })
                            ], 8, _hoisted_25))
                          : _createCommentVNode("", true)
                      ]),
                      _: 2
                    }, 1024)
                  ])
                ])
              ], 2),
              _createElementVNode("div", {
                class: "p-3",
                onClick: ($event: any) => (_unref(selectFile)( file ))
              }, [
                _createElementVNode("div", _hoisted_27, [
                  (file.is_image)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: "absolute inset-0 bg-no-repeat bg-center bg-cover rounded-sm",
                        style: _normalizeStyle(`background-image: url('${file.url}')`)
                      }, null, 4))
                    : (_openBlock(), _createElementBlock("span", _hoisted_28, _toDisplayString(file.file_name.split( '.' ).pop()), 1)),
                  (_unref(store).state.media.previewsEnabled)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                        _createElementVNode("span", {
                          onClick: _withModifiers(($event: any) => (emit( 'preview', file )), ["prevent"]),
                          class: "flex items-center justify-center w-12 h-12 rounded-full cursor-pointer bg-black bg-opacity-25 text-white hover:text-theme hover:bg-white hover:bg-opacity-100 transition duration-150 ease-in-out shadow-lg"
                        }, [
                          _createVNode(_component_x_icon, {
                            icon: "fontawesome.eye",
                            "fa-type": "fas",
                            class: "w-6 h-6"
                          })
                        ], 8, _hoisted_30)
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_31, [
                  _createElementVNode("span", _hoisted_32, _toDisplayString(file.name || file.file_name), 1),
                  _createElementVNode("span", _hoisted_33, _toDisplayString(file.file_name.split( '.' ).pop()), 1)
                ])
              ], 8, _hoisted_26)
            ], 64))
      ], 2))
    }), 128))
  ]))
}
}

})